import * as React from 'react';

import type {AnyAll} from 'nutshell-core/types';

import styles from './filter-divider.module.css';

type FilterDividerProps = {
    isAndable?: boolean;
    anyAll: AnyAll;
    isHovered: boolean;
    onMouseOver: () => any;
    onMouseOut: () => any;
    onClick: () => any;
};
export const FilterDivider = (props: FilterDividerProps) => {
    if (props.isAndable) {
        const value = props.anyAll === 'any' ? 'or' : 'and';

        return (
            <div className={styles['and-or-picker']}>
                <button
                    className={props.isHovered ? styles['btn--hovered'] : styles.btn}
                    onClick={props.onClick}
                    onMouseOver={props.onMouseOver}
                    onMouseOut={props.onMouseOut}
                >
                    {value}
                </button>
            </div>
        );
    }

    return <div className={styles['and-or-picker']}>or</div>;
};
